<template>
    <div class="">
        <form id="teamMembersForm" @submit.prevent="addTeamMembers">
            <div class="page-top mb-1 mb-3 clearfix">
                <h1 class="float-left"> Add Team </h1>
                <button :disabled="form.busy" class="btn btn-primary float-right submit_form">Next</button>
                <router-link to="/teams" class="btn btn-primary float-right mr-1"> Cancel </router-link>
            </div>
            <div class="peopple-managment-main">
                <ul class="page-status">
                    <li class="page-status-list done">
                        <span class="status-highlighter">1</span>
                        Team Details
                    </li>
                    <li class="page-status-list active">
                        <span class="status-highlighter">2</span>
                        Add Team Members
                    </li>
<!--                    <li class="page-status-list">-->
<!--                        <span class="status-highlighter">3</span>-->
<!--                        Confirmation Message-->
<!--                    </li>-->
                </ul>
                <div class="invitee-body">
                    <div class="row">
                        <div class="col-5 people-list">
                            <h3> Employees  </h3>
                            <input type="text" id="search-people" class="form-control" placeholder="Search" autocomplete="off" v-model="search_value" />
                            <div class="people-box" v-for="(user, index) in users" v-bind:key="user.id">
                                <div v-if="getMatchingResults(search_value, user.name)">
                                    <div class="image-holder">
                                        <img :src="`/avatar/${user.avatar}`" @error="$event.target.src = '/images/table-dummy-image.jpg'" alt="" />
                                    </div>
                                    <div class="text-box">
                                        <h4> {{user.name}} </h4>
                                        <p v-if="user.designation==null"> No designation </p>
                                        <p v-else> {{user.designation.name}}  </p>
                                        <span class="team-tag" v-for="team in (user.teams)" v-bind:key="team.id"> {{team.team.name}} </span> 
                                    </div>
                                    <button type="button" @click="flipUserObj(user, index)" class="invite-btn"> Select </button>
                                </div>
                            </div>
                        </div>
                        <div class="col-7 invitee-list" v-if="form.team_members!=0">
                            <h3> Employee Added </h3>
                            <div class="people-box" v-for="(user, index) in form.team_members" v-bind:key="user.id">
                                <div class="image-holder">
                                    <img v-if="user.avatar==null" src="/images/table-dummy-image.jpg" alt="" />
                                    <img v-else :src="`/avatar/${user.avatar}`" alt="" />
                                </div>
                                <div class="text-box">
                                    <h4> {{user.name}} </h4>
                                    <p v-if="user.designation==null"> No designation </p>
                                    <p v-else> {{user.designation.name}}  </p>
                                    <span class="team-tag" v-for="team in (user.teams)" v-bind:key="team.id"> {{team.team.name}} </span> 
                                </div>
                                <button type="button" class="cross-btn" @click="flipBackUserObj(user, index)">
                                    <i class="fas fa-times"></i>
                                </button>
                            </div>
                        </div>
                        <div class="col-7 invitee-list" v-else>
                            <h3> Employee Added </h3>
                            <h5 class="empty-heading" > Their is no team member </h5>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form: new Form({
                    team_members: [],
                    team_member_ids: [],
                    id : this.$route.params.id
                }),
                users : null,
                search_value:''
            }
        },
        methods: {
            getMatchingResults(search, name) {
                if(search == ''){
                    return true
                }else{
                    var new_name = name.toUpperCase();
                    if(new_name.indexOf(search.toUpperCase())>=0){
                        return true;
                    }else{
                        return false;
                    }
                }
            },
            addTeamMembers() {
                this.$Progress.start();
                this.form.post('/api/addTeamMembers/'+this.form.id)
                .then(res => {
                    if(res.status == 200){
                        this.$Progress.finish();
                        toast.fire({
                            type: 'success',
                            title: 'Team members added successfully'
                        });
                        this.$router.push('/teams');
                    }else{
                        this.$Progress.fail();
                        swal.fire({
                            type: 'error',
                            title: 'Some problem in your form data...'
                        });
                    }

                })
                .catch(err => {
                    this.$Progress.fail();
                    swal.fire({
                        type: 'error',
                        title: 'Some problem in your form data'
                    });
                });
            },
            getAddTeamMembersData(){
                this.$Progress.start();
                axios.get('/api/addTeamMembersData')
                .then(res => {
                    if(res.status == 200){
                        this.users = res.data.users;
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                        swal.fire({
                            type: 'error',
                            title: 'Error to load form data'
                        });
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    swal.fire({
                        type: 'error',
                        title: 'Error to load form data'
                    });
                });
            },
            flipUserObj(user, index){
                this.users.splice(index, 1);
                this.form.team_members.push(user);
                this.form.team_member_ids.push(user.id);
            },
            flipBackUserObj(user, index){
                this.form.team_members.splice(index, 1);
                this.form.team_member_ids.splice(index, 1);
                this.users.push(user);
            }
        },
        mounted() {
            this.getAddTeamMembersData();
        }
    }
</script>
